import React from 'react';
import FileUpload from '../../common/input/FileUpload';
import { fileToBase64 } from "../../../helpers/Tools";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import * as ProxyHelper from "../ProxyHelper";


const FILE_SIZE = 5;  //MAX FILE SIZE ALLOWED IN MB.

class MajorUploadDocuments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            showAsInvalid: false,
            tooltipOpen: false
        };
    }

    componentDidMount() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.MajorUploadDocuments.ComponentDidMount${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        this.setState({ mounted: true });
    }

    componentDidUpdate(prevProps) {
        if (prevProps && prevProps.proxyRequestData && prevProps.proxyRequestData.documentSubmitted !== this.props.proxyRequestData.documentSubmitted) {
            this.setState({ isValid: false, showAsInvalid: false });
        }
    }

    componentWillUnmount() {
        this.setState({ mounted: false });
    }

    isValid() {
        return this.isValidate();
    }

    onGoNext(success) {
        const { mounted, fileName, file } = this.state;
        const { proxyRequestData, useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        const { documentSubmitted = false } = proxyRequestData || {};
        let count = listOfSelectedProxyUsers?.length > 0

        if (mounted) {
            //debugger;
            if (this.isValidate() && !documentSubmitted && fileName) {
                logUI(`MBHWeb.UI.ProxyRequest.MajorUploadDocuments.ProofsUploaded.Clicked${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
                this.setState({ showAsInvalid: false });
                const { submitFileInputChange } = this.props;
                if (submitFileInputChange && file) {
                    fileToBase64(file).then(base64Data => {
                        submitFileInputChange(base64Data, file.name, file.name.split(".").pop());
                    });
                }
            }
            else if (!fileName && !documentSubmitted) {
                this.setState({ showAsInvalid: true });
            } else {
                this.setState({ showAsInvalid: false });
            }
        }
    }

    isValidate() {
        return this.state.isValid;
    }

    onInputChange(e, fileName, isValid, file) {
        if (fileName && file)
            this.setState({ showAsInvalid: false, fileName, file });
        else
            this.setState({ showAsInvalid: true, fileName: "", file: null });
        this.setState({ isValid: isValid }, () => this.isValidate());

    }

    toggleTooltip = () => {
        this.setState(prevState => ({
            tooltipOpen: !prevState.tooltipOpen
        }));
    }

    proofSubmitted = () => {
        const { proxyRequestData, useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.MajorUploadDocuments.ProofsAlreadySubmitted.Clicked${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        if (this.props.onGoNext) {
            this.props.onGoNext(true, { ...proxyRequestData, attachments: [], documentSubmitted: true });
            this.setState({ isValid: true, fileName: "", file: null }, () => {
                this.props.goNext();
            });
        }
    }

    render() {
        const { style, validFileTypes, showInfo, isMinor, healthrecord, pharmacy } = this.props;
        const { showAsInvalid, tooltipOpen } = this.state;
        const containerClassName = showAsInvalid ? " input-invalid" : "";
        const validFileTypesNoSpace = validFileTypes.replace(/ /g, ""); //removing spaces in case if value of app.config key MedicalRecordProxyFileTypes has spaces.
        let hintText = validFileTypesNoSpace.toUpperCase().split(".").join("").split(",").join(", ");
        const indexOfLastComma = hintText.lastIndexOf(",");
        if (indexOfLastComma > 0)
            hintText = hintText.substr(0, indexOfLastComma) + ", or " + hintText.substr(indexOfLastComma + 2); //replace index of last comma with or
        return (
            <div className={"request-upload-doc-container" + containerClassName} style={style}>
                <div className="row">
                    <div className="col-12">
                        <h1 className="step-heading step-heading-md">{this.props.title}</h1>
                        {showInfo && isMinor &&
                            /*<div className="input-icon-append">
                                <span className="icon-info" id="fileupload" />
                                <Tooltip placement="top" isOpen={tooltipOpen} autohide={false} target="fileupload" toggle={this.toggleTooltip}>
                                    Examples of acceptable documents include:  Letters of Guardianship, Durable Power of Attorney, Medical Consenter, Custody Documentation
                                </Tooltip>
                            </div>*/
                            <p className="step-description">
                                Ex: Letters of Guardianship, Durable Power of Attorney, Medical Consenter, Custody Documentation <br /><br />
                            <a href="https://www.bswhealth.com/SiteCollectionDocuments/patient-tools/form-proxy-child-mychart-bsw.pdf" target="_blank">Or print and upload this document signed by the biological parent</a>
                            </p>
                        }

                        {showInfo && !isMinor &&
                            <p className="step-description">
                                Ex: Letter of Guardianship, Court Orders, Medical Power of Attorney, Adult Protective Services document <br /><br />
                            <a href="https://www.bswhealth.com/SiteCollectionDocuments/patient-tools/form-proxy-adult-mychart-bsw.pdf" target="_blank">Or you can also print and upload this document</a>
                            </p>
                        }
                    </div>
                </div>

                <div className="row page-form-sm">
                    <div className="col-12 form-group">
                        <div className="form-group">
                            <FileUpload type="file"
                                accept={validFileTypesNoSpace}
                                onChange={(e, fileName, isValid, file) => this.onInputChange(e, fileName, isValid, file)}
                                placeholder="Upload a document"
                                showAsInvalid={showAsInvalid}
                                maxFileSize={FILE_SIZE}
                                required
                                value={this.state.fileName}
                                fileTypeErrorMsg="Please upload the correct file type."
                                fileSizeErrorMsg={`Please upload a file smaller than ${FILE_SIZE}MB.`}
                                shouldShowError={!this.state.isValid}
                            />
                        </div>
                        <div className="hint-text">{`Accepted file types: ${hintText}. Max file size: ${FILE_SIZE}MB.`}</div>
                    </div>
                </div>

                { healthrecord &&
                    <div className="row">
                    <div className={"col-12 text-center proof-sub-btn"}>
                            <button className="btn text-btn" onClick={this.proofSubmitted}>I've already submitted proof</button>
                        </div>
                    </div>
                }

            </div>
        );
    };
}

 MajorUploadDocuments.defaultProps = {
    validFileTypes: ".docx,.pdf,.jpg,.png,.gif" //No spaces here , accept attribute of input is a string
};

export default MajorUploadDocuments;